import request from "./request.js";
// import requestocy from './requestocy.js'
import school from "./school.js";

const origin = process.env.VUE_APP_DATA_API
//获取图形验证码
function getverification(time) {
  return request("/login/generateValidateCode", "POST", {
    time: time,
  });
}

//直播手机号登录
function loginByVerificationCodeForCourse(phone, code, time, imageCode, type) {
  return request("/livec/login/loginByVerificationCodeForCourse", "POST", {
    phone,
    code,
    time,
    imageCode,
    type,
  });
}
//观看方式
function roomwatchytype() {
  return request("/LiveRoomWatchType/getInfo", "POST", {});
}
//type1免费观看
function roomwatchytypefree() {
  return request("/LiveRoomWatchType/free", "POST", {});
}
//type2付费观看
function roomwatchytypepay(stype) {
  return request("/LiveRoomWatchType/pay", "POST", {
    stype,
  });
}
//type3密码观看
function roomwatchytypeencryption(passWord) {
  return request("/livec/login/checkPassWord", "POST", {
    passWord,
  });
}
//type4账号观看
function roomwatchytypephone(phone) {
  return request("/LiveRoomWatchType/phone", "POST", {
    phone,
  });
}
//检查支付状态
function roomwatchytypeverifyPay(orderNum) {
  return request("/LiveRoomWatchType/verifyPay", "POST", {
    orderNum,
  });
}
//type5报名观看
function roomwatchytypesubmit(data) {
  return request("/LiveRoomWatchType/submit", "POST", data);
}
//type6邀请码观看
function roomwatchytypeinvite(code) {
  return request("/LiveRoomWatchType/invite", "POST", {
    code,
  });
}
//验证观看方式是否认证过
function roomwatchytypeverify() {
  return request("/LiveRoomWatchType/verify", "POST", {});
}
//获取房间token
function getusertoken(nickname, userLogin, isUpdate) {
  return request("/room/getUserToken", "POST", {
    nickname,
    userLogin,
    isUpdate,
  });
}
//获取房间基础信息
function roomconfig() {
  return request("/livec/liveRoom/allConfig", "POST", {});
}
// 获取免审词
function getfreepassword() {
  return request("/livec/liveRoom/autoPassMessage", "POST", {});
}
// 获取敏感词
function getSensitiveWord() {
  return request("/livec/liveRoom/sensitiveWord", "POST", {});
}
//获取房间自定义菜单信息
function getroomconfigtags() {
  return request("/roomTagConfig/getRoomConfigTags", "POST", {});
}
//获取房间视频信息
function getroombindvideos() {
  return request("/roomTagConfig/getRoomBindVideos", "POST", {});
}
//获取礼物信息
function getclientgift() {
  return request("/liveGiftConfig/getClientGift", "POST", {});
}

//校验微信登陆二维码
function checkwxqrcode(code) {
  return request("/login/checkWxQrCode", "POST", {
    code,
  });
}
//标记二维码已使用
function savewxqrcode(code) {
  return request("/ocLogin/saveWxQrCode", "POST", {
    code,
  });
}
//创建礼物支付订单
function createpcorderbygift(id) {
  return request("/pay/createPcOrderByGift", "POST", {
    id,
  });
}
//检查礼物订单支付状态
function wxcheckorder(orderNum) {
  return request("/pay/checkOrder", "POST", {
    orderNum,
  });
}

//获取房间基本信息
function getwatchroombasevo() {
  return request("/room/getWatchRoomBaseVo", "POST", {});
}
//获取房间跑马灯
function getroommarquee() {
  return request("/roomMarquee/info", "POST", {});
}
//打赏获取支付链接
function createorderbyreward(price) {
  return request("/pay/createPcOrderByReward", "POST", {
    price,
  });
}
//设置观看人数
function setwatchlookbase() {
  return request("/roomConfig/setWatchLookBase", "POST", {});
}
//获取累计观看人数
function getwatchlookbase() {
  return request("/roomConfig/getWatchLookBase", "POST", {});
}
//获取用户连麦信息
function getusertrtcsign(account) {
  return request("/room/getUserTRTCSign", "POST", {
    account,
  });
}
//获取商品列表
function getroomcommodity(page, pageSize) {
  // return request("/roomConfig/getRoomCommodity", "POST", {
  //   page,
  //   pageSize,
  // });
  return request("/livec/liveProduct/saleList", "POST", {
    page,
    pageSize,
  });
}
//支付商品
function createcommodity(id, account) {
  return request("/pay/createPCOrderByCommodity", "POST", {
    id,
    account,
  });
}
//上报外部商品点击
function escalation(commodityId) {
  return request("/room/escalationH5Check", "POST", {
    commodityId,
  });
}
//获取累计观看人数
function getlookbase() {
  return request("/roomConfig/getWatchLookBase", "POST", {});
}
//获取客服列表
function getroomcustomer() {
  return request("/roomCustomer/list", "POST", {});
}
//获取关注信息
function getfollow() {
  return request("/roomConfig/getFollow", "POST", {});
}
//获取回看地址
function getbackinfo() {
  return request("/roomLookBack/info", "POST", {});
}
//签到
function signadd(data) {
  return request(
    "/live/interaction/signIn",
    "POST",
    data,
    origin
  );
}

//续签到
function needsign(data) {
  return request(
    "/live/interaction/queryRoomSignInIng",
    "POST",
    data,
    origin
  );
}


//购买数据上报
function productPV(query) {
  return request("/dataGateway/trade/report/productPV", "POST", query, origin);
}
//聊天设置
function livechatinfo() {
  return request("/LiveChat/info", "POST", {});
}
function getAppidByLogin() {
	return request('/login/wxOpen/getAppid', "POST", {})
}
//校验token
function livechecktoken(token) {
  return request("/login/checkToken", "POST", {});
}
//获取观看地址
function livewatchurl() {
  return request("/room/watchUrl", "POST", {});
}
//取消认证
function delwatchtype() {
  return request("/LiveRoomWatchType/delWatchType", "POST", {});
}
//添加系统数据
function addsystemlog(account) {
  return request("/room/addSystemLog", "POST", {
    account,
  });
}
//添加商品点击,ocy
function addCommodityClick(data) {
  return request("/roomConfig/addCommodityClick", "POST", data);
}
//观看时长上报,ocy
function AddWatchTime(data) {
  return request("/userWatchClassStatistics/AddWatchTime", "POST", data);
}
//观看时长结束上报,ocy
function AddWatchTimeEnd(data) {
  return request("/userWatchClassStatistics/AddWatchTimeEnd", "POST", data);
}
//获取评价列表
function getAllPassEvaluate(lecturerId) {
  return request("/roomTagConfig/getAllPassEvaluate", "POST", {
    lecturerId,
  });
}

//登录im
function loginIm(data) {
  return request("/livec/login/liveIm/Login", "POST", data);
}
// 签到
function sign(data) {
  return request("/roomUserSign/add", "POST", data);
}
//发表讲师评价
function addTeacherEvaluate(
  lecturerId,
  headUrl,
  account,
  nickName,
  evaluate,
  score
) {
  return request("/roomTagConfig/addTeacherEvaluate", "POST", {
    lecturerId,
    headUrl,
    account,
    nickName,
    evaluate,
    score,
  });
}
//获取推荐商品信息
// function getRecommendCommodityInfo() {
//   return request("/room/getRecommendCommodityInfo", "POST", {});
// }
//推荐商品上报
function escalationCheck(data) {
  return request("/room/escalationCheck", "POST", data);
}
//PC支付-推荐商品
function createPCOrderByRecommendCommodity(account, id) {
  return request("/pay/createPCOrderByRecommendCommodity", "POST", {
    account,
    id,
  });
}
//获取商品入口图片
function getCommodityListIcon() {
  return request("/roomConfig/getCommodityListIcon", "POST", {});
}
//获取机构logo和背景（全局）
function getCharacter() {
  return request("/room/getCharacter", "POST", {});
}
//获取讲师信息
function getLecturerInfo(lecturerId) {
  return request("/roomTagConfig/getLecturerInfo", "POST", {
    lecturerId,
  });
}
//获取讲师信息
function getChannelData(id) {
  return request("/channel/getChannelData", "POST", {
    id,
  });
}
// 直播互动次数上报
function addMsgCount(data) {
  return request("/AddSendMsgCount", "POST", data);
}

// 卡片采集
function SubmitCardList(data) {
  return request("/interfaceCard/SubmitCardList", "POST", data);
}

// 订单场控点击记录采集
function addOrderControlRecord(data) {
  return request("/orderField/addOrderControlRecord", "POST", data);
}

// 抽奖---获取直播间是否有正在进行的抽奖
function getRoomHavingDraw() {
  return request("/draw/getRoomHavingDraw", "POST");
}

// 抽奖---获取直播间抽奖信息
function getDraw(id) {
  return request("/draw/getDraw", "POST", { id });
}

// 抽奖---查看是否中奖
function checkPrizeUser(data) {
  return request("/draw/checkPrizeUser", "POST", data);
}

// 抽奖---查看中奖名单
function getPrizeCache(drawId, index, count) {
  return request("/draw/getPrizeCache", "POST", { drawId, index, count });
}

// 抽奖---提交兑奖信息
function submitDrawList(data) {
  return request("/draw/submitDrawList", "POST", data);
}

// 检验是否已经领取
function checkCoupon(query) {
	return request('/livec/coupon/checkCustomReceiveState', "POST", query)
}
//当前正在发放的优惠券
function getCouponIngByRoom(query) {
	return request('/livec/coupon/queryCouponIngByRoom', "POST", query)
}

// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// 直播部分
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
//获取直播基础信息
function getCourseInfo() {
  return request("/livec/api/course/getCourseInfo", "POST", {});
}
//获取直播子母表
function getCourseClass() {
  return request("/livec/api/course/getCourseClass", "POST", {});
}
//获取直播课程表
function getCourseList(courseClassId) {
  return request("/livec/api/course/getCourseList", "POST", {
    courseClassId,
  });
}
//获取直播用户信息
function getUserInfo() {
  return request("/livec/personalCenter/getUserInfo", "POST", {});
}
//获取个人中心绑定信息
function getPersonalCenterInfo() {
  return request("/livec/personalCenter/getPersonalCenterInfo", "POST", {});
}
//修改直播用户信息
function updateUserInfo(data) {
  return request("/livec/personalCenter/updateUserInfo", "POST", data);
}
//获取直播观看历史
function getUserWatchHistoryList(page, pageSize) {
  return request("/personalCenter/getUserWatchHistoryList", "POST", {
    page,
    pageSize,
  });
}
//获取绑定微信授权码
function getWxEmpowerQrCode(path) {
  return request("/appointClassVaildateController/getWxEmpowerQrCode", "POST", {
    path,
  });
}
//获取章节index
function getCourseIndex(sectionId) {
  return request("/api/course/getCourseIndex", "POST", {
    sectionId,
  });
}
//用户校验
function checkUser() {
  // return request('/livec/login/checkUser', "POST", { })
  return request("/livec/login/checkUserIsWhite", "POST", {});
}
//用户校验
function checkPassWord() {
  // return request('/livec/login/checkUser', "POST", { })
  return request("/livec/login/checkPassWordIsLogin", "POST", {});
}
//验证手机号占用状态
function loginByAppointVerificationCode(data) {
  return request(
    "/appointClassVaildateController/loginByAppointVerificationCode",
    "POST",
    data
  );
}
//检查二维码
function checkWxEmpowerQrCode(code) {
  return request(
    "/appointClassVaildateController/checkWxEmpowerQrCode",
    "POST",
    {
      code,
    }
  );
}
//绑定手机号
function mergeUser(phone) {
  return request("/appointClassVaildateController/mergeUser", "POST", {
    phone,
  });
}
//验证手机号绑定状态

//获取手机号账户信息
function getUserClassData(phone) {
  return request("/appointClassVaildateController/getUserClassData", "POST", {
    phone,
  });
}
//绑定微信账号(无冲突)
function empowerUserByNoConflict(data) {
  return request(
    "/appointClassVaildateController/empowerUserByNoConflict",
    "POST",
    data
  );
}
//获取微信账号对比表
function getUserClassDataByWxId(userId) {
  return request(
    "/appointClassVaildateController/getUserClassDataByWxId",
    "POST",
    {
      userId,
    }
  );
}
//绑定微信账号(冲突合并)
function empowerUserByPC(userId) {
  return request("/appointClassVaildateController/empowerMergeUser", "POST", {
    userId,
  });
}
//直播密码验证
function checkEncryption(passWord) {
  return request("/livec/login/checkEncryption", "POST", {
    passWord,
  });
}
//直播白名单账号验证
function checkAccount(phone) {
  return request("/livec/login/checkAccount", "POST", {
    phone,
  });
}
//直播付费观看
function createPcOrderByCourseWatch(account) {
  return request("/pay/createPcOrderByCourseWatch", "POST", {
    account,
  });
}
//直播数据上报
function addUserWatchData(data) {
  return request(
    "/livec/userWatchClassStatistics/addUserWatchData",
    "POST",
    data
  );
}

//最后一次登录上报
function UserLoginData(data) {
  return request("/livec/userWatchClassStatistics/userLoginData", "POST", data);
}
//我的课程
function getUserCourseList(page, pageSize) {
  return request("/livec/personalCenter/getUserCourseList", "POST", {
    page,
    pageSize,
  });
}

// 直播API接口对应表

// 绑定手机号确认 - 不需要验证
function verificationByRebindUnCheck(data) {
  return request("/login/mobile/verificationByRebindUnCheck", "POST", data);
}

// 绑定手机号确认 - 需要验证
function verificationByRebind(data) {
  return request("/login/mobile/verificationByRebind", "POST", data);
}
//刷新token
function refreshToken(data) {
  return request("/livec/login/refresh", "POST", data);
}
//绑定手机号发送短信验证码
function sendsmscourse(phone, time, imageCode) {
  return request("/login/mobile/getVerificationCode", "POST", {
    phone,
    time,
    imageCode,
  });
}
//手机号登录
function loginforphone(phone, code, time, imageCode, type) {
  return request("/login/loginByVerificationCode", "POST", {
    phone,
    code,
    time,
    imageCode,
    type,
  });
}
//获取二维码
function getwxqrcode(path) {
  return request("/login/getWxQrCode", "POST", {
    path,
  });
}

//发送短信验证码
function sendsms(phone, time, imageCode) {
  return request("/login/getVerificationCode", "POST", {
    phone,
    time,
    imageCode,
  });
}

// 下单接口
function generateOrder(data) {
  return request("/order/place", "POST", data);
}
// 获取微信支付参数
function getwxorderconfig(query) {
  return request("/pay/", "POST", query);
}

function getRecommendCommodityInfo() {
  return request('/livec/liveProduct/queryRecommendProduct', "POST", {

  })
}

// 领取优惠券
function receiveCoupon(query) {
	return request('/livec/coupon/receiveCoupon', "POST", query)
}
// 查询用户是否报名
function querySignedUp({}) {
	return request('/liveSignupUser/querySignedUp', "POST", {})
}
// 填写报名表单 
function addOrUpdateSignupUser(data) {
	return request('/liveSignupUser/addOrUpdate', "POST", data)
}
// 开播上报
function fillBaseUser(params) {
	return request('/baseUser/fillBaseUser', "POST", params, origin);
}


export default {
  ...school,
  refreshToken,
  getUserInfo,
  getLecturerInfo,
  mergeUser,
  UserLoginData,
  getChannelData,
  getUserCourseList,
  empowerUserByPC,
  addUserWatchData,
  checkEncryption,
  checkAccount,
  createPcOrderByCourseWatch,
  getUserClassDataByWxId,
  empowerUserByNoConflict,
  loginByAppointVerificationCode,
  verificationByRebindUnCheck,
  verificationByRebind,
  loginByVerificationCodeForCourse,
  checkUser,
  checkPassWord,
  getUserClassData,
  checkWxEmpowerQrCode,
  getWxEmpowerQrCode,
  getCourseIndex,
  getPersonalCenterInfo,
  getUserWatchHistoryList,
  updateUserInfo,
  getCourseList,
  getCourseInfo,
  getCourseClass,
  sendsms,
  AddWatchTime,
  getCharacter,
  getRecommendCommodityInfo,
  createPCOrderByRecommendCommodity,
  escalationCheck,
  AddWatchTimeEnd,
  getAllPassEvaluate,
  addTeacherEvaluate,
  addsystemlog,
  sendsmscourse,
  getverification,
  loginforphone,
  roomwatchytype,
  getusertoken,
  roomconfig,
  getfreepassword,
  getSensitiveWord,
  loginIm,
  getroomconfigtags,
  getroombindvideos,
  getclientgift,
  getwxqrcode,
  checkwxqrcode,
  savewxqrcode,
  createpcorderbygift,
  wxcheckorder,
  roomwatchytypeverify,
  roomwatchytypefree,
  roomwatchytypeencryption,
  getwatchroombasevo,
  getroommarquee,
  getCommodityListIcon,
  roomwatchytypepay,
  roomwatchytypeinvite,
  roomwatchytypeverifyPay,
  roomwatchytypephone,
  createorderbyreward,
  setwatchlookbase,
  getwatchlookbase,
  roomwatchytypesubmit,
  getusertrtcsign,
  getroomcommodity,
  createcommodity,
  escalation,
  getlookbase,
  getroomcustomer,
  getfollow,
  getbackinfo,
  signadd,
  needsign,
  livechatinfo,
  livechecktoken,
  getAppidByLogin,
  livewatchurl,
  delwatchtype,
  addCommodityClick,
  addMsgCount,
  SubmitCardList,
  getRoomHavingDraw,
  addOrderControlRecord,
  checkPrizeUser,
  getPrizeCache,
  submitDrawList,
  checkCoupon,
  getCouponIngByRoom,
  getDraw,
  generateOrder,
  getwxorderconfig,
  productPV,
  receiveCoupon,
  querySignedUp,
  addOrUpdateSignupUser,
  fillBaseUser
};
